// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"603":"6153eaf7","787":"9e25daf4","844":"8d1c8114"}[chunkId] + ".chunk.js";
};